import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    children: [
      {
        path: "/overview",
        name: "Overview",
        component: () =>
          import(/* webpackChunkName: "carts" */ "../views/Overview.vue")
      },
      {
        path: "/carts",
        name: "Carts",
        component: () =>
          import(/* webpackChunkName: "carts" */ "../views/Carts.vue")
      },
      {
        path: "/templates",
        name: "Templates",
        component: () =>
          import(/* webpackChunkName: "templates" */ "../views/Templates.vue")
      },

      {
        path: "/analytics",
        name: "Analytics",
        component: () =>
          import(/* webpackChunkName: "reports" */ "../views/Analytics.vue")
      },
      {
        path: "/extension/onboarding",
        name: "ExtensionOnboarding",
        component: () =>
          import(
            /* webpackChunkName: "extnonboarding" */ "../views/ExtensionOnboarding.vue"
          )
      },
      {
        path: "/chatextension/onboarding",
        name: "ChatExtensionOnboarding",
        component: () =>
          import(
            /* webpackChunkName: "extnonboarding" */ "../views/ChatExtensionOnboarding.vue"
          )
      },

      {
        path: "/report/:reportId",
        name: "Report",
        component: () =>
          import(/* webpackChunkName: "report" */ "../views/ReportDetails.vue")
      },
      {
        path: "/semiautomation/",
        name: "SemiAutomation",
        component: () =>
          import(/* webpackChunkName: "automation" */ "../views/Automation.vue")
      },
      {
        path: "/automation/",
        name: "FullyAutomated",
        redirect: { name: "AutomationConfigure" },
        component: () =>
          import(
            /* webpackChunkName: "automation" */ "../views/FullyAutomated.vue"
          ),
        children: [
          {
            path: "configure",
            name: "AutomationConfigure",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/AutomationConfigureForm.vue"
              )
          },
          {
            path: "orderconfirmation",
            name: "OrderConfirmation",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/OrderConfirmation.vue"
              )
          },
          {
            path: "ordershipping",
            name: "OrderShippingUpdates",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/OrderShippingUpdates.vue"
              )
          },
          {
            path: "codorder",
            name: "CodOrder",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/CodOrder.vue"
              )
          },
          {
            path: "/integrations/",
            name: "Integrations",
            redirect: { name: "IntegrationList" },
            component: () =>
              import(
                /* webpackChunkName: "integrations" */ "../views/Integrations/Integrations.vue"
              ),
            children: [
              {
                path: "list",
                name: "IntegrationList",
                component: () =>
                  import(
                    /* webpackChunkName: "integrations" */ "../views/Integrations/IntegrationList.vue"
                  )
              },
              {
                path: "reviews/:appName",
                name: "ReviewsHome",
                redirect: { name: "ReviewsSettings" },
                component: () =>
                  import(
                    /* webpackChunkName: "integrations" */ "../views/Integrations/Reviews/ReviewsHome.vue"
                  ),
                children: [
                  {
                    path: "settings",
                    name: "ReviewsSettings",
                    component: () =>
                      import(
                        /* webpackChunkName: "integrations" */ "../views/Integrations/Reviews/ReviewsSettings.vue"
                      )
                  },
                  {
                    path: "scheduled",
                    name: "ReviewsScheduled",
                    component: () =>
                      import(
                        /* webpackChunkName: "integrations" */ "../views/Integrations/Reviews/ReviewsScheduled.vue"
                      )
                  },
                  {
                    path: "messagelogs",
                    name: "ReviewsMessageLogs",
                    component: () =>
                      import(
                        /* webpackChunkName: "integrations" */ "../views/Integrations/Reviews/ReviewsMessageLogs.vue"
                      )
                  }
                ]
              }
            ]
          },
          {
            path: "additionalreminder",
            name: "AdditionalAbandonedReminder",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/AdditionalAbandonedCartReminder.vue"
              )
          },
          {
            path: "faqs",
            name: "Faqs",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/Faqs.vue"
              )
          },
          {
            path: "messagelogs",
            name: "MessageLogs",
            component: () =>
              import(
                /* webpackChunkName: "automation" */ "../views/Automation/MessageLogs.vue"
              )
          }
        ]
      },
      {
        path: "/chat/",
        name: "Chat",
        redirect: { name: "ChatConfigure" },
        component: () =>
          import(
            /* webpackChunkName: "chat" */ "../views/ChatAndShare/ChatAndShare.vue"
          ),
        children: [
          {
            path: "configure",
            name: "ChatConfigure",
            component: () =>
              import(/* webpackChunkName: "chat" */ "../views/Chat.vue")
          },
          {
            path: "share",
            name: "ShareConfigure",
            component: () =>
              import(/* webpackChunkName: "chat" */ "../views/Share.vue")
          },
          {
            path: "othersettings",
            name: "ChatOtherSettings",
            component: () =>
              import(
                /* webpackChunkName: "chat" */ "../views/ChatAndShare/OtherSettings.vue"
              )
          },
          {
            path: "/crm/",
            name: "CRM",
            component: () =>
              import(/* webpackChunkName: "chat" */ "../views/Crm.vue")
          }
        ]
      },

      {
        path: "/orders",
        name: "Orders",
        component: () =>
          import(/* webpackChunkName: "orders" */ "../views/Order/Order.vue")
      },
      {
        path: "/settings",
        name: "Settings",
        redirect: { name: "Plan" },
        component: () =>
          import(/* webpackChunkName: "settings" */ "../views/Settings.vue"),
        children: [
          {
            path: "/plan",
            name: "Plan",
            component: () =>
              import(/* webpackChunkName: "settings" */ "../views/Plan.vue")
          },
          {
            path: "/notifications/",
            name: "Notifications",
            component: () =>
              import(
                /* webpackChunkName: "chat" */ "../views/Notifications.vue"
              )
          },
          {
            path: "/preference/",
            name: "Preference",
            component: () =>
              import(
                /* webpackChunkName: "preference" */ "../views/Preference.vue"
              )
          },
          {
            path: "/language/",
            name: "Language",
            component: () =>
              import(
                /* webpackChunkName: "preference" */ "../views/Language.vue"
              )
          }
        ]
      },

      {
        path: "/manualmessage/",
        name: "ManualMessageError",
        component: () =>
          import(
            /* webpackChunkName: "manualmessage" */ "../views/ManualMessageSolution.vue"
          )
      },
      {
        path: "/inbox/",
        name: "InboxHome",
        component: () =>
          import(
            /* webpackChunkName: "teaminbox" */ "../views/TeamInbox/InboxHome.vue"
          )
      },
      {
        path: "/inboxalert/",
        name: "InboxAlert",
        component: () =>
          import(
            /* webpackChunkName: "teaminbox" */ "../views/TeamInbox/InboxAlert.vue"
          )
      },

      {
        path: "/broadcast/",
        name: "Broadcast",
        component: () =>
          import(
            /* webpackChunkName: "broadcast" */ "../views/Broadcast/Broadcast.vue"
          )
      },
      {
        path: "/marketingandupsells/",
        name: "MarketingAndUpsell",
        redirect: { name: "Marketing" },
        component: () =>
          import(
            /* webpackChunkName: "upsell" */ "../views/MarketingAndUpsell.vue"
          ),
        children: [
          {
            path: "/marketing/",
            name: "Marketing",
            redirect: { name: "Campaigns" },
            component: () =>
              import(
                /* webpackChunkName: "marketing" */ "../views/Marketing.vue"
              ),
            children: [
              {
                path: "templates/",
                name: "MarketingTemplates",
                component: () =>
                  import(
                    /* webpackChunkName: "marketing" */ "../views/Marketing/Templates.vue"
                  )
              },
              {
                path: "campaigns/",
                name: "Campaigns",
                component: () =>
                  import(
                    /* webpackChunkName: "campaigns" */ "../views/Marketing/Campaigns.vue"
                  )
              },
              {
                path: "createcampaign/",
                name: "CreateCampaign",
                component: () =>
                  import(
                    /* webpackChunkName: "campaigns" */ "../views/Marketing/CreateCampaign.vue"
                  )
              },
              {
                path: "campaigndetail/:campaignId",
                name: "CampaignDetail",
                component: () =>
                  import(
                    /* webpackChunkName: "marketing" */ "../views/Marketing/CampaignDetail.vue"
                  )
              },
              {
                path: "messagelogs/",
                name: "MarketingMessageLogs",
                component: () =>
                  import(
                    /* webpackChunkName: "marketing" */ "../views/Marketing/MessageLogs.vue"
                  )
              }
            ]
          },
          {
            path: "/upsell/",
            name: "Upsell",
            redirect: { name: "Upsells" },
            component: () =>
              import(/* webpackChunkName: "upsell" */ "../views/Upsell.vue"),
            children: [
              {
                path: "upsells/",
                name: "Upsells",
                component: () =>
                  import(
                    /* webpackChunkName: "upsells" */ "../views/Upsell/Upsells.vue"
                  )
              },
              {
                path: "createupsell/",
                name: "CreateUpsell",
                component: () =>
                  import(
                    /* webpackChunkName: "createupsell" */ "../views/Upsell/CreateUpsell.vue"
                  )
              },
              {
                path: "upselldetail/:upsellId",
                name: "UpsellDetail",
                component: () =>
                  import(
                    /* webpackChunkname: "upselldetail" */ "../views/Upsell/UpsellDetail.vue"
                  )
              },
              {
                path: "scheduled/",
                name: "UpsellScheduled",
                component: () =>
                  import(
                    /* webpackChunkName: "upselldetail" */ "../views/Upsell/UpsellScheduled.vue"
                  )
              },
              {
                path: "messagelogs/",
                name: "UpsellMessageLogs",
                component: () =>
                  import(
                    /* webpackChunkName: "upselldetail" */ "../views/Upsell/MessageLogs.vue"
                  )
              },
              {
                path: "analytics/:upsellId",
                name: "UpsellAnalytics",
                component: () =>
                  import(
                    /* webpackChunkName: "upselldetail" */ "../views/Upsell/UpsellAnalytics.vue"
                  )
              }
            ]
          }
        ]
      },

      {
        path: "/instagram/",
        name: "Instagram",
        component: () =>
          import(
            /* webpackChunkName: "instagram" */ "../views/InstagramFollowBooster.vue"
          )
      }
    ]
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () =>
      import(/* webpackChunkName: "plan" */ "../views/Onboarding.vue")
  },
  {
    path: "/privacy-policy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPolicy.vue")
  },
  {
    path: "/incident",
    component: () =>
      import(/* webpackChunkName: "incident" */ "../views/Incident.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/cod/:shortCode",
    name: "Cod",
    component: () =>
      import(/* webpackChunkName: "cod" */ "../views/Cod/Cod.vue")
  },
  {
    path: "/judgeme/:shortCode",
    name: "Judgeme",
    component: () =>
      import(/* webpackChunkName: "judgeme" */ "../views/Judgeme/Judgeme.vue")
  },
  {
    path: "/loox/:shortCode",
    name: "LooxReview",
    component: () =>
      import(
        /* webpackChunkName: "looxreview" */ "../views/Loox/LooxReview.vue"
      )
  },
  {
    path: "/trustedreviews/:shortCode",
    name: "TrustedReviews",
    component: () =>
      import(
        /* webpackChunkName: "trustedreviews" */ "../views/TrustedReviews/TrustedReviews.vue"
      )
  },
  {
    path: "/redirect",
    name: "Redirect",
    component: () =>
      import(/* webpackChunkName: "Redirect" */ "../views/Redirect.vue")
  },
  {
    path: "/auth/:token",
    name: "AuthRedirect",
    component: () =>
      import(/* webpackChunkName: "Redirect" */ "../views/AuthRedirect.vue")
  },
  {
    path: "/teaminbox/:token",
    name: "TeamInboxAuthRedirect",
    component: () =>
      import(
        /* webpackChunkName: "Redirect" */ "../views/TeamInboxAuthRedirect.vue"
      )
  },
  {
    path: "/checkout/:checkoutId",
    name: "Checkout",
    component: () =>
      import(/* webpackChunkName: "publiccheckout" */ "../views/Checkout.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
